<template>
  <div class="animated fadeIn">
    <b-tabs card>
      <b-tab title="Projects" active>
        <b-row class="mb-3">
          <b-col align-h="between">
            <span class="display-3 font-2xl">Projects</span>
          </b-col>
          <b-col class="d-flex flex-row-reverse">
            <b-button
              v-show="checkPermission('add project')"
              :variant="'success'"
              @click="addNewProject"
            >
              <i class="fal fa-plus" />
            </b-button>
          </b-col>
        </b-row>
        <project-server-table />
      </b-tab>
      <b-tab title="Orders">
        <h3>Orders</h3>
        <invoice-server-table />
      </b-tab>
      <b-tab title="Results">
        <h3>Results</h3>
        <result-server-table />
      </b-tab>
      <b-tab title="Notes">
        <NotesDisplay :notes_attachable_id="$route.params.customer_id" notes_attachable_type="customer" />
      </b-tab>
      <b-tab title="Growers">
        <b-row class="mb-3">
          <b-col align-h="between">
            <h3>Growers</h3>
          </b-col>
          <b-col class="d-flex flex-row-reverse">
            <b-button
              :variant="'success'"
              :to="`/customer/${customer.id}/growers/add`"
            >
              <i class="fal fa-plus" />
            </b-button>
          </b-col>
        </b-row>
        <CustomerGrowerServerTable :customer_id="customer.id" />
      </b-tab>
      <b-tab title="Fields">
        <b-row class="mb-3">
          <b-col align-h="between">
            <h3>Fields</h3>
          </b-col>
          <b-col class="d-flex flex-row-reverse">
            <b-button
              :variant="'success'"
              :to="`/customer/${customer.id}/fields/add`"
            >
              <i class="fal fa-plus" />
            </b-button>
          </b-col>
        </b-row>
        <CustomerFieldServerTable :customer_id="customer.id" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import InvoiceServerTable from "@/components/cashier/invoice/InvoiceServerTable";
import ProjectServerTable from "@/components/lab/project/ProjectServerTable";
import ResultServerTable from "@/components/modus/result/ResultServerTable";
import CustomerModel from "@/models/crm/CustomerModel";
import { AccessControlCheck } from "@/auth/AccessControlCheck"
import { mapActions } from "vuex";
import NotesDisplay from "@/components/shared/NotesDisplay.vue";
import CustomerGrowerServerTable from "@/components/crm/customergrower/CustomerGrowerServerTable"
import CustomerFieldServerTable from "@/components/crm/customerfield/CustomerFieldServerTable"

export default {
  name: "CustomerDetailCardstack",
  components: {
    InvoiceServerTable,
    ResultServerTable,
    ProjectServerTable,
    NotesDisplay,
    CustomerGrowerServerTable,
    CustomerFieldServerTable
  },
  props: {
    customer: {
      type: Object,
      default: () => new CustomerModel()
    }
  },
  methods: {
    ...mapActions(["UPDATE_STEP_ONE"]),
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    addNewProject() {
      this.UPDATE_STEP_ONE({
        name: "filter",
        value: this.customer.short_name
      });
      this.UPDATE_STEP_ONE({
        name: "customer_id",
        value: this.customer.id
      });

      this.$router.push("/projects/add");
    }
  }
};
</script>
